import { Injectable, ElementRef, Optional } from '@angular/core';
import { StateMachine, FrameContext, AppContext } from '@farris/devkit';
// tslint:disable: max-line-length
/**
 * ç¶ææºæå¡
 * @scope FrameComponent
 */
@Injectable()
class StateMachineService {
  constructor(
    @Optional() private stateMachine: StateMachine
  ) {
    if (this.stateMachine && this.stateMachine.initialState.name === 'init') {
      window.setTimeout(() => {
        this.initFormState();
      }, 0);
    }
  }

  private _clsDefaultName = 'f-form-state-default';
  private _initLoad = true;
  private _currentFrameContext: any;

  transit(action: string) {
    if (this.stateMachine && action && typeof this.stateMachine[action] === 'function') {
      this.stateMachine[action]();
      this._currentFrameContext = this['context'] && this['context']['frameContext'];
      if (this._initLoad) {
        this.initFormState();
        this._initLoad = false;
      }
      if (!this._currentFrameContext) {
        return;
      }
      const currentRootFrameContext = this.getCurrentRootFrameContext(this._currentFrameContext);
      if (!!currentRootFrameContext) {
        this.toggleFormState(action, currentRootFrameContext);
      }
    }
  }

  private getCurrentRootFrameContext(currentFrameContext: FrameContext): FrameContext {
    let currentRootFrameContext: FrameContext;
    this.getAllRootFrameContext().forEach((rootFc: FrameContext) => {
      if (currentFrameContext.namespace === rootFc.namespace) {
        currentRootFrameContext = rootFc;
      }
    });
    return currentRootFrameContext;
  }

  private getFrameContextManagerMap() {
    if (this.stateMachine && this.stateMachine.frameContext) {
      const appContext = this.stateMachine.frameContext.appContext as AppContext;
      if (appContext) {
        const frameContextManager = appContext.frameContextManager;
        return frameContextManager.getFrameContextMap();
      }
    }
    return null;
    // return this.stateMachine && this.stateMachine.frameContext && this.stateMachine.frameContext.appContext && this.stateMachine.frameContext.appContext.frameContextManager && this.stateMachine.frameContext.appContext.frameContextManager.getFrameContextMap();
  }

  private getAllRootFrameContext(): any[] {
    const rootFrameContextArr = [];
    const frameContexts = this.getFrameContextManagerMap();
    if (frameContexts) {
      frameContexts.forEach((item) => {
        if (this.isRootFrameContext(item)) {
          rootFrameContextArr.push(item);
        }
      });
    }
    return rootFrameContextArr;
  }
  private isRootFrameContext(frameContext: FrameContext) {
    return (frameContext.namespace === '' && frameContext.parent === null) ||
      (frameContext.parent !== null && frameContext.namespace !== frameContext.parent.namespace) ||
      frameContext.frameComponent.isRootLayout;
  }
  private initFormState() {
    if (!this.getFrameContextManagerMap()) {
      return;
    }
    this.getAllRootFrameContext().forEach((rootFc: FrameContext) => {
      const rootComponent = rootFc.injector.get<ElementRef>(ElementRef, null) || null;
      if (!rootComponent || !rootComponent.nativeElement) {
        return;
      }
      if (!rootComponent.nativeElement.className.includes(this._clsDefaultName) && !rootComponent.nativeElement.className.includes('f-form-state-create') && !rootComponent.nativeElement.className.includes('f-form-state-edit')) {
        this.addCssClass(rootComponent, this._clsDefaultName);
      }
    });
  }

  private toggleFormState(action: string, frameContext: FrameContext) {
    const rootComponent = frameContext.injector.get<ElementRef>(ElementRef, null) || null;
    if (!rootComponent || !rootComponent.nativeElement || !action) {
      return;
    }
    action = action.toLowerCase();
    if (action && ['create', 'edit'].includes(action)) {
      if (action === 'create') {
        this.addCssClass(rootComponent, 'f-form-state-create');
      } else if (action === 'edit') {
        this.addCssClass(rootComponent, 'f-form-state-edit');
      }
      this.removeCssClass(rootComponent, this._clsDefaultName);
    } else {
      ['f-form-state-create', 'f-form-state-edit'].forEach(item => this.removeCssClass(rootComponent, item));
      this.addCssClass(rootComponent, this._clsDefaultName);
    }
  }
  private addCssClass(elementRef: ElementRef, className: string) {
    if (!elementRef || !className || !elementRef.nativeElement) {
      return;
    }
    const originalClassName: string = elementRef.nativeElement.className || '';
    if (!originalClassName.includes(className)) {
      elementRef.nativeElement.className = `${originalClassName} ${className}`;
    }
  }
  private removeCssClass(elementRef: ElementRef, className: string) {
    if (!elementRef || !className || !elementRef.nativeElement) {
      return;
    }
    const originalClassName: string = elementRef.nativeElement.className || '';
    if (originalClassName.includes(className)) {
      elementRef.nativeElement.className = originalClassName.split(' ').filter(p => p && p !== className).join(' ');
    }
  }
  private getFormRootComponent() {
    if (this.stateMachine && this.stateMachine.frameContext) {
      const viewContext = this.stateMachine.frameContext;
      if (viewContext) {
        const virtualRootContext = viewContext.getVirtualRootFrameContext();
        if (virtualRootContext) {
          const injector = virtualRootContext.injector;
          if (typeof injector.get === 'function') {
            return injector.get<ElementRef>(ElementRef, null);
          }
        }
      }
    }
    return null;
    // return this.stateMachine && this.stateMachine.frameContext && this.stateMachine.frameContext.getVirtualRootFrameContext() && this.stateMachine.frameContext.getVirtualRootFrameContext().injector && typeof this.stateMachine.frameContext.getVirtualRootFrameContext().injector.get === 'function' && this.stateMachine.frameContext.getVirtualRootFrameContext().injector.get<ElementRef>(ElementRef, null) || null;
  }
}

export { StateMachineService };
